/* eslint-disable import/extensions */
/* eslint-disable react/no-array-index-key */
import React from 'react'
import { shape, arrayOf, string, oneOfType } from 'prop-types'
import 'components/banner-row/banner-row.scss'
import RichText from 'components/rich-text'
import Banner from 'components/cms/components/banner'

const BannerRow = ({
  moduleData: { banners: Banners, ...props }, name, type, moduleId,
}) => (
  <div
    className="banner-row"
    data-module={name}
    data-module-name={name}
    data-module-id={moduleId}
    data-module-type={type}
  >
    {Banners.map((banner, i) => {
      const className = `${props[`internalColumnClass${i + 1}`]}`
      if (banner.type === 'Banner') {
        return <Banner moduleData={banner} className={className} key={i} />
      }
      if (banner.type === 'RichText') {
        return (<RichText
          key={i}
          content={banner.markup}
          className={`banner-static ${className}`}
        />)
      }
      return null
    })
  }
  </div>
)

BannerRow.propTypes = {
  moduleData: shape({
    containerClass: string,
    internalColumnClass1: string,
    internalColumnClass2: string,
    internalColumnClass3: string,
    internalColumnClass4: string,
    internalColumnClass5: string,
    internalColumnClass6: string,
    banners: arrayOf(oneOfType([
      shape({
        type: string,
        mediaURL: shape({
          clickThrough: shape({
            value: string,
          }),
        }),
        altText: string,
        linkDestination: shape({
          clickThrough: shape({
            value: string,
          }),
        }),
      }),
      shape({
        type: string,
        markup: string,
      }),
    ])),
  }).isRequired,
  name: string,
  moduleId: string,
  type: string,
}

BannerRow.defaultProps = {
  name: null,
  moduleId: null,
  type: null,
}

export default BannerRow



// WEBPACK FOOTER //
// ./components/banner-row/index.js